import { TranslationsTypes } from './translation.model';

export enum stepCategory {
    category1 = 'GS_STEP_CATEGORY1',
    category2 = 'GS_STEP_CATEGORY2',
    category3 = 'GS_STEP_CATEGORY3',
    category4 = 'GS_STEP_CATEGORY4'
}

export interface IWelcomeStep {
    Completed: boolean;
    Created: Date;
    CreatedBy: string;
    Id: string;
    InternalIdentifier: string;
    LastModified: Date;
    LastModifiedBy: string;
    Optional: boolean;
    Order: number;
    Step: string;
    TenantId: string;
}

export interface IStep {
    nameStart: TranslationsTypes;
    nameComplete: TranslationsTypes;
    descStart: TranslationsTypes;
    descComplete: TranslationsTypes;
    buttonStart: TranslationsTypes;
    buttonComplete: TranslationsTypes;
    category: string;
    linkLocation: string;
    completed: boolean;
}

export interface IStepCategory {
    categoryName: TranslationsTypes;
    steps: IStep[];
}

export interface ITrialDaysRemaining {
    DaysRemaining: number;
    Licensed: boolean;
    Next: Date;
    State: string;
}